<template>
  <v-card outlined class="rounded-lg">
    <v-card-title class="subtitle-1 font-weight-bold">
      <v-icon color="primary" class="mr-2">mdi-chart-line</v-icon>Team trend
      <v-spacer />
      <span class="caption grey--text">average growth score by month</span>
    </v-card-title>
    <v-card-text>
      <v-progress-linear v-if="loading" indeterminate />
      <v-alert v-else-if="error" type="error" dense outlined>{{ error }}
        <v-btn small text @click="load">Retry</v-btn>
      </v-alert>
      <AdminTrendChart v-else :buckets="buckets" />
      <div v-if="truncated" class="caption grey--text mt-1">Showing the latest 36 months.</div>
    </v-card-text>
  </v-card>
</template>

<script>
import AdminTrendChart from './AdminTrendChart.vue'
import { getTrend } from '@/services/adminGrowthService'

export default {
  name: 'AdminTeamTrendCard',
  components: { AdminTrendChart },
  props: {
    range: { type: Object, required: true },
    refreshToken: { type: Number, default: 0 },
  },
  data() {
    return { buckets: [], truncated: false, loading: false, error: null }
  },
  watch: {
    range: { handler: 'load', deep: true },
    refreshToken: 'load',
  },
  created() { this.reqId = 0 },
  mounted() { this.load() },
  methods: {
    async load() {
      const { from, to } = this.range
      if (!from || !to || (from !== 'all' && from > to)) return
      const id = ++this.reqId
      this.loading = true; this.error = null
      try {
        const data = await getTrend(from, to)
        if (id !== this.reqId) return
        this.buckets = data.buckets || []
        this.truncated = !!data.truncated
      } catch (e) {
        if (id !== this.reqId) return
        this.error = e.message
      } finally {
        if (id === this.reqId) this.loading = false
      }
    },
  },
}
</script>
